import { ComboboxMulti } from 'twyne-new.ui';

import DateTimeRange from '../components/Filters/DateTimeRange';
import Select from '../components/Filters/Select';
import SelectAsync from '../components/Filters/SelectAsync';
import SelectCreatable from '../components/Filters/SelectCreatable';
import SelectCreatableAsync from '../components/Filters/SelectCreatableAsync';
import { useGrid } from '../context';
import { useFilterOptionsSelect } from '../hooks/filters';

export default function filter(name, label = '') {
  return {
    name, label,
    isMulti: false,

    component(Component) {
      this.Component = Component
      return this;
    },

    multi(value) {
      this.isMulti = value;
      return this;
    },

    creatable(value) {
      this.creatable = value;
      return this;
    },

    setOptions(options) {
      this.options = options;
      return this;
    },

    getValue(formatter) {
      this.formatValue = formatter;
      return this;
    },

    setValue(formatter) {
      this.onChange = formatter;
      return this;
    },

  }
}

const selectStoreOptions = (storeList, config) => ({ ...props }) => {
  const { store: { lists: { [storeList]: store } } } = useGrid()

  if (!store) {
    throw new Error(`Store list "${storeList}" not found`)
  }

  const options = useFilterOptionsSelect(store, config)

  return <Select {...props}
    options={options}
    {...props.isMulti && { Component: ComboboxMulti }}
  />
}

const selectOptions = options => ({ ...props }) => <Select {...props}
  options={options}
  {...props.isMulti && { Component: ComboboxMulti }}
/>

const BOOLEAN_OPTIONS = [{ label: "True", value: true }, { label: "False", value: false }]

export const components = {
  select: {
    basic: Select,
    async: SelectAsync,
    creatable: SelectCreatable,
    creatableAsync: SelectCreatableAsync,
  },
  date: DateTimeRange,
}

filter.options = {
  store: (name, label, storeList, config) => filter(name, label).component(selectStoreOptions(storeList, config)),
  list: (name, label, options) => filter(name, label).component(selectOptions(options)),
}

filter.boolean = (name, label) => filter.options.list(name, label, BOOLEAN_OPTIONS)
